import { render } from "./ContentBlockModal.vue?vue&type=template&id=7e5c182b&ts=true"
import script from "./ContentBlockModal.vue?vue&type=script&lang=ts"
export * from "./ContentBlockModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/Blocks/ContentBlockModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e5c182b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e5c182b', __exports__)) {
    api.reload('7e5c182b', __exports__)
  }
  
  module.hot.accept("./ContentBlockModal.vue?vue&type=template&id=7e5c182b&ts=true", () => {
    api.rerender('7e5c182b', render)
  })

}


export default __exports__